import React, { Component } from "react";

import AgGridReactEx from "@app/components/AgGridReactEx";

const easyFilter = [
    {
        displayKey: "포함",
        displayName: "키워드 포함",
        test: function (filterValue, cellValue) {
            if (cellValue == null) return false;
            return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {
        displayKey: "일치",
        displayName: "키워드 일치",
        test: function (filterValue, cellValue) {
            return filterValue == cellValue;
        },
    },
];

const numberFilter = [
    {
        displayKey: "이상",
        displayName: "이상",
        test: function (filterValue, cellValue) {
            return Number(filterValue) <= Number(cellValue);
        },
    },
    {
        displayKey: "이하",
        displayName: "이하",
        test: function (filterValue, cellValue) {
            return Number(filterValue) >= Number(cellValue);
        },
    },
    {
        displayKey: "일치",
        displayName: "일치",
        test: function (filterValue, cellValue) {
            return Number(filterValue) == Number(cellValue);
        },
    },
];

const rateCellRenderer = (value, rate) => {
    var html = `<div class="row">`;
    html += "<div class='col pr-0 text-right'>" + value.toLocaleString() + "</div>";
    if (rate < 0) {
        html += '<div class="col pl-0 text-left ml-2 text-danger" style="font-size:12px;"><i class="fa fa-fw fa-arrow-down"></i>' + rate * -1 + "%</div>";
    } else if (rate > 0) {
        html += '<div class="col pl-0 text-left ml-2 text-primary" style="font-size:12px;"><i class="fa fa-fw fa-arrow-up"></i>' + rate + "%</div>";
    } else {
        html += '<div class="col pl-0 text-left ml-2 text-info" style="font-size:12px;"></div>';
    }
    html += `</div>`;

    return html;
};

const growthCellRenderer = (rate) => {
    var html = "<div class='row'>" + "<div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-1 text-center'>";

    if (rate == 0) {
        html += '<span class="text-info" style="font-size:12px;"><i class="fa fa-fw fa-arrow-right"></i>' + rate + "%</span>";
    } else if (rate < 0) {
        html += '<span class="text-danger" style="font-size:12px;"><i class="fa fa-fw fa-arrow-down"></i>' + rate * -1 + "%</span>";
    } else {
        html += '<span class="text-primary" style="font-size:12px;"><i class="fa fa-fw fa-arrow-up"></i>' + rate + "%</span>";
    }

    return html + "</div>";
};

const progressWithGrowthCellRenderer = (value, rate, growth) => {
    var html = "";

    html += "<div>";
    html += '    <div class="row progress-title">';
    html += '        <div class="col-8" style="padding-right:0px">';
    html += "            <div style='text-align : center'>" + value + "</div>";
    html += "        </div>";
    html += '        <div class="col-4 text-left" style="padding-left:0px">';
    if (growth == 0) {
        html += " ";
    } else if (growth > 0) {
        html += '       <span class="text-primary" style="font-size:10px;"><i class="fa fa-fw fa-arrow-up"></i>' + growth + "%</span>";
    } else {
        html += '       <span class="text-danger" style="font-size:10px;"><i class="fa fa-fw fa-arrow-down"></i>' + growth * -1 + "%</span>";
    }
    html += "        </div>";
    html += "    </div>";
    html += '    <div class="progress progress-lg text-center" style="background:#8c8c8c;">';
    html += '        <span class="progress-value">' + rate + "%</span>";
    html += '        <div class="progress-bar" role="progressbar" style="width: ' + rate + '%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>';
    html += "    </div>";
    html += "</div>";

    return html;
};

export default class BranchList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: this.props.bizYear,
            dataList: null,
            tableData: null,
            keyword: null,
        };
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState(
            {
                year: nextProps.bizYear,
                dataList: nextProps.dataList,                
            },
            () => {
                this.setState({ tableData: this.listSearch(this.state.keyword) });
            }
        );
    };

    searchData = (e) => {
        var keyword = e.target.value;

        var tableData = this.listSearch(keyword);

        this.setState({
            tableData: tableData,
            keyword: keyword,
        });
    };

    listSearch = (keyword) => {
        var isKeezle = this.props.selectedApp ? this.props.selectedApp.id == 'keezle' : false;
        var list = this.state.dataList;
        var tableData = [];
        if (!keyword) {
            tableData = list;
        } else {
            list.map((item) => {
                if (item.name && item.name.indexOf(keyword) >= 0) {
                    tableData.push(item);
                }
            });
        }
        return tableData;
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        const sortModel = [{ colId: "statYear.total", sort: "desc" }];
        this.gridApi.setSortModel(sortModel);
    };

    rowClick = (agGrid) => {
        // document.location.href = "/metrics/contract/branch?id=" + agGrid.api.selectionController.lastSelectedNode.data.id + "&year="+this.state.year;
        if (this.props.onRowClick) {
            this.props.onRowClick(agGrid.api.selectionController.lastSelectedNode.data.id);
        }
    };

    rowDataChanged = (params) => {
        this.setState({
            tableSummary: this.state.tableData.length.toLocaleString() + " / " + this.state.dataList.length.toLocaleString(),
        });
    };

    filterChanged = (params) => {
        this.setState({
            tableSummary: params.api.rowModel.rowsToDisplay.length.toLocaleString() + " / " + this.state.dataList.length.toLocaleString(),
        });
    };

    render() {
        const listColumn = [
            {
                headerName: this.props.isBranch ? "지사" : "원",
                field: "name",
                sortable: true,
                minWidth: 155,
                headerClass: "bg-dark text-light",
                cellClass: "text-left",
                resizable: true,
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: easyFilter,
                },
            },
            {
                headerName: "전체",
                field: "statYear.total",
                sortable: true,
                minWidth: 150,
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: numberFilter,
                },
                cellRenderer: (param) => {
                    return rateCellRenderer(param.value, param.data.statYear.total_growth);
                },
            },
            {
                headerName: "신규",
                field: "statYear.new",
                sortable: true,
                minWidth: 110,
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: numberFilter,
                },
                cellRenderer: (param) => {
                    return rateCellRenderer(param.value, param.data.statYear.new_growth);
                },
            },
            {
                headerName: "재계약",
                field: "statYear.renew",
                sortable: true,
                minWidth: 160,
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: numberFilter,
                },
                cellRenderer: (param) => {
                    return progressWithGrowthCellRenderer(param.data.statYear.renew + " / " + param.data.statYear.last_total, param.data.statYear.renew_rate, param.data.statYear.renew_growth);
                },
            },
            {
                headerName: "점유율",
                field: "statYear.rate",
                sortable: true,
                minWidth: 80,
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: numberFilter,
                },
                cellRenderer: (param) => {
                    return param.value.toFixed(2) + "%";
                },
            },
            {
                headerName: "성장률",
                field: "statYear.total_growth",
                sortable: true,
                minWidth: 80,
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: numberFilter,
                },
                cellRenderer: (param) => {
                    return growthCellRenderer(param.value);
                },
            },
            /*, 
            {
                headerName: "BCG",
                field: "bcg",
                sortable: true,
                minWidth : 135,
                cellClass: "text-center",
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: easyFilter
                }
            }
            */
        ];
        if (this.state.tableData == null) {
            return (
                <div className="card">
                    <div className="card-body" style={{ height: (this.props.height + 70) + "px", textAlign: "center", paddingTop: "50px" }}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            );
        } else if (this.state.dataList.length == 0) {
            return (
                <div className="card">
                    <div className="card-body" style={{ height: (this.props.height + 70) + "px" }}>
                        No Data
                    </div>
                </div>
            );
        } else {
            return (
                <div className="card">
                    <div className="card-body pl-0 pb-0 pr-0">
                        <div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-2 pl-5 float-right table-total-summary">{this.state.tableSummary}</div>
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2 pr-5 float-right">
                                <input className="form-control" type="text" onChange={this.searchData} placeholder="search keyword" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <AgGridReactEx
                                    height={this.props.height}
                                    columnDefs={listColumn}
                                    rowData={this.state.tableData}
                                    onRowDataChanged={this.rowDataChanged}
                                    onGridReady={this.onGridReady}
                                    onFilterChanged={this.filterChanged}
                                    rowSelection="single"
                                    onSelectionChanged={this.rowClick}
                                    pagination={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
